"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.request = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var request = function request(_ref) {
  var data = _ref.data,
      method = _ref.method,
      params = _ref.params,
      url = _ref.url,
      headers = _ref.headers,
      withCredentials = _ref.withCredentials;
  return new Promise(function (resolve, reject) {
    (0, _axios["default"])({
      data: data,
      headers: headers,
      method: method,
      params: params,
      url: "".concat(url),
      withCredentials: withCredentials
    }).then(function (response) {
      resolve({
        data: response.data
      });
    })["catch"](function (error) {
      reject(new Error(error));
    });
  });
};

exports.request = request;
var _default = _axios["default"];
exports["default"] = _default;